export default {
  agreement: 'Agreement',
};
